import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Phone, MessageCircle, Globe, Instagram, MapPin } from "lucide-react";

export default function ContactSection() {
  const [cfg, setCfg] = useState({ contact: {}, whatsapp_number: "" });
  useEffect(() => {
    api.get("/config/public").then((r) => setCfg(r.data)).catch(() => {});
  }, []);
  const c = cfg.contact || {};
  const wa = cfg.whatsapp_number || "919353480980";

  return (
    <section id="contact" data-testid="contact-section" className="py-24 md:py-32 bg-background">
      <div className="container mx-auto px-6 md:px-12 max-w-7xl">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <p className="overline mb-4">For Bookings & Enquiries</p>
            <h2 className="font-display text-4xl sm:text-5xl text-foreground font-medium leading-[1.05] tracking-tight">
              Contact our Team.
            </h2>
            <p className="mt-6 font-sans text-base text-muted-foreground leading-relaxed">
              We answer fastest on WhatsApp. For meal pre-orders, group bookings or airport pickup,
              please share details when you message us.
            </p>

            <div className="mt-10 space-y-4">
              <a
                href={`tel:${(c.phone_1 || "").replace(/\s+/g, "")}`}
                className="flex items-center gap-4 group"
                data-testid="contact-phone-1"
              >
                <span className="w-11 h-11 rounded-full border border-border flex items-center justify-center group-hover:border-primary group-hover:text-primary transition-colors">
                  <Phone size={16} strokeWidth={1.5} />
                </span>
                <span className="font-display text-xl">{c.phone_1}</span>
              </a>
              <a
                href={`tel:${(c.phone_2 || "").replace(/\s+/g, "")}`}
                className="flex items-center gap-4 group"
                data-testid="contact-phone-2"
              >
                <span className="w-11 h-11 rounded-full border border-border flex items-center justify-center group-hover:border-primary group-hover:text-primary transition-colors">
                  <Phone size={16} strokeWidth={1.5} />
                </span>
                <span className="font-display text-xl">{c.phone_2}</span>
              </a>
              <a
                href={`https://wa.me/${wa}`}
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-4 group"
                data-testid="contact-whatsapp"
              >
                <span className="w-11 h-11 rounded-full border border-border flex items-center justify-center group-hover:border-[#25D366] group-hover:text-[#25D366] transition-colors">
                  <MessageCircle size={16} strokeWidth={1.5} />
                </span>
                <span className="font-display text-xl">WhatsApp us</span>
              </a>
              <a
                href="https://instagram.com/aroha.homes"
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-4 group"
                data-testid="contact-instagram"
              >
                <span className="w-11 h-11 rounded-full border border-border flex items-center justify-center group-hover:border-primary group-hover:text-primary transition-colors">
                  <Instagram size={16} strokeWidth={1.5} />
                </span>
                <span className="font-display text-xl">@aroha.homes</span>
              </a>
              <div className="flex items-center gap-4">
                <span className="w-11 h-11 rounded-full border border-border flex items-center justify-center">
                  <Globe size={16} strokeWidth={1.5} />
                </span>
                <span className="font-display text-xl">arohahomes.com</span>
              </div>
            </div>
          </div>

          <div className="md:col-span-7">
            <div className="rounded-2xl overflow-hidden border border-border h-full min-h-[420px] bg-muted relative">
              <iframe
                title="Aroha Homes location — Madikeri, Coorg"
                data-testid="contact-map"
                src="https://www.google.com/maps?q=Madikeri,Coorg,Karnataka,India&output=embed"
                className="absolute inset-0 w-full h-full"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
            <p className="mt-3 flex items-center gap-2 text-sm text-muted-foreground font-sans">
              <MapPin size={14} strokeWidth={1.5} /> Madikeri, Kodagu (Coorg), Karnataka, India
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
